module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/purple/timely_guidance_icon-f1804ccc76c1f7a9ea3076b482aee723.svg";